import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { BackboneComponent } from '@components/backbone/backbone.component';
import { BreadcrumbComponent } from '@components/breadcrumb/breadcrumb.component';
import { TabViewModule } from 'primeng/tabview';
import { TagModule } from 'primeng/tag';
import { ShowForRolesDirective } from '@directives/show-for-roles.directive';
import { UploadComponent } from './upload/upload.component';

@Component({
  selector: 'app-contrasena-ciec-ine',
  imports: [CommonModule, BackboneComponent, BreadcrumbComponent, TagModule, TabViewModule, ShowForRolesDirective, UploadComponent],
  templateUrl: './contrasena-ciec-ine.component.html',
  styleUrl: './contrasena-ciec-ine.component.scss',
})
export class ContrasenaCiecInePage {}
